import { routerLinkSlugs } from '../i18n/router-links';

export function toInternationalizedRoute<
  T extends any[] | string | null | undefined,
>(routerLink: T): T {
  if (typeof routerLink === 'string') {
    return (routerLinkSlugs[routerLink] ?? routerLink) as T;
  } else if (Array.isArray(routerLink)) {
    return routerLink.map((slug) => routerLinkSlugs[slug] ?? slug) as T;
  } else {
    return routerLink as T;
  }
}
